let options = [
  {
    label: 'Concrete St George UT (Term-City-State)',
    value: 'termCityState',
    format: ({ term, city, stateCode }) => `${term} ${city} ${stateCode}`,
  },
  {
    label: 'St George Concrete (City-Term)',
    value: 'cityTerm',
    format: ({ term, city }) => `${city} ${term}`,
  },
]

export let formatQuery = (id, props) =>
  options.find(o => o.value === id).format(props)

export default options
